import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import authApi from '@/api/auth'
import cookie from '@/plugins/cookie'
import { USER } from '@/utils/constants'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    token: cookie.get('token')
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setToken (state, token) {
      const MONTH_OF_SECONDS = 24 * 60 * 60 * 30

      state.token = token
      cookie.set('token', token, MONTH_OF_SECONDS)
    }
  },
  actions: {
    getUser ({ commit }) {
      return authApi.getUser()
        .then(resp => {
          commit('setUser', resp)
          commit('setToken', resp.api_token)
        })
        .catch(() => {
          commit('setToken', '')
          commit('setUser', {})
          cookie.del('token')
          router.push({ name: 'login' })
        })
    },
    logout ({ commit }) {
      commit('setToken', '')
      commit('setUser', {})
      cookie.del('token')
    }
  },
  getters: {
    isLogin (state) {
      return !!(state.token)
    },
    roleType (state) {
      switch (state.user.role) {
        case USER.role.student:
          return 'student'
        case USER.role.assistant:
          return 'assistant'
        default:
          return ''
      }
    },
    accountType (state) {
      switch (state.user.account_type) {
        case USER.account_type.sat:
          return 'sat'
        case USER.account_type.ntu:
          return 'ntu'
        default:
          return ''
      }
    },
    userIdentity: (state, { roleType, accountType }) => () => {
      return accountType + roleType.charAt(0).toUpperCase() + roleType.slice(1)
    }
  },
  modules: {
  }
})
